
import React, { useEffect, Suspense } from 'react';
import Header from '@/components/dashboard/Header';
import { Toaster } from '@/components/ui/toaster';
import { useDashboardData } from '@/hooks/useDashboardData';
import LoadingState from '@/components/dashboard/LoadingState';
import PwaInstallBanner from '@/components/ui-elements/PwaInstallBanner';
import PwaUpdateNotifier from '@/components/ui-elements/PwaUpdateNotifier';
import { useAppSettings } from '@/hooks/useAppSettings';
import DashboardHeader from '@/components/dashboard/sections/DashboardHeader';
import PwaInstaller from '@/components/ui-elements/PwaInstaller';
import MainUserSection from '@/components/dashboard/sections/MainUserSection';
import DashboardSections from '@/components/dashboard/sections/DashboardSections';
import DashboardFooter from '@/components/dashboard/sections/DashboardFooter';

const Dashboard: React.FC = () => {
  const { 
    loading, 
    profile, 
    rewards, 
    pointTransactions,
    lastCheckIn,
    userBadges,
    refreshUserData,
    updateProfileLocally 
  } = useDashboardData();
  const { updatePwaAssets } = useAppSettings();
  
  useEffect(() => {
    // Update PWA assets when dashboard loads
    updatePwaAssets();
  }, [updatePwaAssets]);

  if (loading || !profile) {
    return <LoadingState />;
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Header profile={profile} />
      
      <main className="container mx-auto px-4 py-8">
        <PwaUpdateNotifier />
        
        <DashboardHeader profile={profile} />
        
        {/* Main user information section - high priority */}
        <MainUserSection 
          profile={profile}
          loading={loading}
          lastCheckIn={lastCheckIn}
          refreshUserData={refreshUserData}
          updateProfileLocally={updateProfileLocally}
        />
        
        {/* All dashboard content sections */}
        <DashboardSections 
          userId={profile.id}
          profile={profile}
          rewards={rewards}
          pointTransactions={pointTransactions}
          userBadges={userBadges || []}
          refreshUserData={refreshUserData}
        />
      </main>
      
      <DashboardFooter />
      
      <PwaInstallBanner />
      <PwaInstaller />
      <Toaster />
    </div>
  );
};

export default Dashboard;
